import http from '../../../libs/http'
import config from '../../../config/amortizations'
export default (queryParams = {}) => http.get(`${config.api}/sap-accounts/search`, { params: { ...queryParams } })
